import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import CountUp from 'react-countup';
import { InView } from 'react-intersection-observer';
import * as styles from './InNumbers.module.scss';

function InNumbers({ inNumbers: { numbers: destinationNumbers, isDark } }) {
  const getStartNumbers = () => destinationNumbers.map((number) => ({ ...number, number: 0 }));

  const [numbers, setNumbers] = useState(getStartNumbers());

  return (
    <div className={`${isDark ? styles.dark : null} py-6`}>
      <Container>
        <InView onChange={(inView) => (inView ? setNumbers(destinationNumbers) : null)}>
          <Row>
            {numbers.map((number) => (
              <CountUp key={number._key} start={0} end={number.number} duration={3}>
                {({ countUpRef }) => (
                  <Col xs={12} sm={6} lg={3} className={`${isDark ? 'text-white' : 'text-gray-750'} text-right`}>
                    <div className={`${styles.counterDivider} font-weight-light text-nowrap mb-4`}>
                      <span className="text-size-7xl" ref={countUpRef} />
                      {number.suffix && <span className="text-size-7xl">{number.suffix}</span>}
                    </div>
                    <div className={`${isDark ? 'text-gray-400' : ''} font-weight-semi-bold`}>{number.title}</div>
                  </Col>
                )}
              </CountUp>
            ))}
          </Row>
        </InView>
      </Container>
    </div>
  );
}

export default InNumbers;
